import { render, staticRenderFns } from "./LancamentoDeFrequenciaComplementarPage.vue?vue&type=template&id=6629bc8e&scoped=true"
import script from "./LancamentoDeFrequenciaComplementarPage.vue?vue&type=script&lang=js"
export * from "./LancamentoDeFrequenciaComplementarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629bc8e",
  null
  
)

export default component.exports